import { Level, Logger, ConsoleHandler } from 'simple-logging-lib';
import { ErrorHandler } from './ErrorHandler';
import memoizeOne from 'react-utils/memoizeOne';
export const LOGGER_NAME = 'nav-onboarding-tours/target-element-observer';
export const DEBUG_KEY = 'TARGET_ELEMENT_OBSERVER_DEBUG';
export const isDebugEnabled = () => {
  try {
    return localStorage.getItem(DEBUG_KEY) === 'true';
  } catch (error) {
    return false;
  }
};
const removeExistingHandlersOfType = type => {
  const logger = Logger.getLogger(LOGGER_NAME);
  logger.getHandlers().forEach(handler => {
    if (handler instanceof type) {
      logger.removeHandler(handler);
    }
  });
};
export const setupLogger = memoizeOne(() => {
  const logger = Logger.getLogger(LOGGER_NAME);
  logger.setLevel(isDebugEnabled() ? Level.DEBUG : Level.ERROR);
  removeExistingHandlersOfType(ConsoleHandler);
  logger.addHandler(new ConsoleHandler({
    useColor: 'rgb(181, 171, 32)'
  }));
  logger.debug('Debug logging enabled');
});
export const addErrorHandler = memoizeOne(onError => {
  const logger = Logger.getLogger(LOGGER_NAME);
  removeExistingHandlersOfType(ErrorHandler);
  logger.addHandler(new ErrorHandler(onError));
});